module.exports = __webpack_public_path__ + "static/img/login_left.fbe8180c.svg";